<template>
    <div id="recognition_journal">
      <div class="journal-title">
        <div @dblclick.ctrl="open_debug_tool">
          <h1 >{{ $i18n.t('pages.main.journal.title') }}</h1>
        </div>
        <v-text-field
            v-model="search"
            :label="$i18n.t('general.search')"
            append-icon="mdi-magnify"
            outlined
            clearable
            class="search-field rounded_8px height_56px"
            background-color="#FFFFFF"
            @input="fetchEntriesDebounced"
        />
        <file-export page="RecognitionJournal">
          <template v-slot:button>
            <v-btn
                class="white--text mr-1 ml-1"
                style="border-radius: 4px"
                color="#DBEAF1"
                elevation="0"
                height="42"
            >
              <v-icon>$icon_file_download</v-icon>
              <span class="main_color button-font">{{ $i18n.t('pages.vehicles_lists.data_export.title') }}</span>
            </v-btn>
          </template>
        </file-export>
      </div>
      <div>
        <v-data-table style="margin-top: 20px"
          dense
          item-key="_id"
          :headers="journal_table_headers"
          :items="recognized_plates_list"
          :item-class="plate_access_color"
          :items-per-page="itemsPerPage"
          :loading="table_loading"
          :loading-text="$i18n.t('general.loading')"
          hide-default-footer
        >
          <template v-slot:item.license_plate = "{ item }">
            <v-chip
                outlined color="#207EA9"
                style="height: 24px;
                        box-sizing: border-box;
                        border-radius: 8px;
                        width: 105px;
                        display: flex; justify-content: center"
            >
              <span :style="{color: item.text_color}" class="table-font">{{item.license_plate}}</span>
            </v-chip>
          </template>
          <template v-slot:item.detection_datetime = "{ item }">
            <span :style="{color: item.text_color}">
            {{ date_obj_to_datetime_str(datetime_obj=item.detection_datetime) }}
            </span>
          </template>
          <template v-slot:item.country = "{ item }">
            <span :style="{color: item.text_color}">
            {{ item.country }}
            </span>
          </template>
          <template v-slot:item.source = "{ item }">
            <span :style="{color: item.text_color}">
            {{ item.source }}
            </span>
          </template>
          <template v-slot:item.time_of_presence = "{ item }">
            <span :style="{color: item.text_color}">
            {{ prepare_time_of_precense(item.time_of_presence)}}
            </span>
          </template>
          <template v-slot:item.owner_fio = "{ item }">
            <span :style="{color: item.text_color}">
            {{ item.owner_fio }}
            </span>
          </template>
          <template #footer.page-text="props">
            <span>
              {{
                $i18n.t(
                  'table_footers.some_rows_of_all',
                  {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`}
                )
              }}
            </span>
          </template>
        </v-data-table>
      </div>
      <div style="display: flex; justify-content: center">
        <div style="justify-self: center;margin-left: 400px; width: 600px; margin-top: 10px">
        <v-pagination
            v-model="page"
            :length=pageCount
            :total-visible="7"
            @input="fetch_search_data"
            ></v-pagination>
          </div>
        <div style="margin-left: 400px">
          <v-select
              :items="rows_per_page"
              :label="$i18n.t('table_footers.rows_per_page')"
              @change="SetItemsPerPage"
          ></v-select>
          </div>
         </div>
        </div>
</template>

<script>
import store from "@/store";
import {EventBus} from "@/bus";
import 'moment-timezone'
import moment from 'moment'
import { i18n } from "@/i18n";
import {custom_table_filters} from "@/mixins/custom_table_filters";
import {custom_table_sorts} from "@/mixins/custom_table_sorts";
import {date_time_converters} from "../mixins/date_time_converters";
import {common_funcs} from "@/mixins/common";
import FileExport from "@/components/FileExport";

export default {
  components: {
      FileExport
  },
  name: "RecognitionJournal",
  mixins: [custom_table_filters, custom_table_sorts, date_time_converters, common_funcs],
  data: function() {

      EventBus.$on('ws_on_message', this.ws_on_message)

      return {
        page: 1,
        pageCount: 10,
        itemsPerPage: 20,
        rows_per_page: [10, 20, 30, 50, 100],
        store: store,
        table_loading: true,
        ws_flag: true,
        search: '',
        journal_table_headers: [
          {
            text: i18n.t('pages.main.journal.table.headers.license_plate'),
            align: 'start', sortable: false, value: 'license_plate'
          },
          {
            text: i18n.t('pages.main.journal.table.headers.datetime'),
            value: 'detection_datetime', sortable: false,
          },
          {
            text: i18n.t('pages.main.journal.table.headers.country'),
            value: 'country', sortable: false
          },
          {
            text: i18n.t('pages.main.journal.table.headers.source'),
            value: 'source', sortable: false
          },
          {
            text: i18n.t('pages.main.journal.table.headers.time_of_presence'),
            value: 'time_of_presence', sortable: false,
          },
          {
            text: i18n.t('pages.main.journal.table.headers.owner_name'),
            value: 'owner_fio', sortable: true
          },
        ],
        recognized_plates: [],
      }
    },
  methods: {
    SetItemsPerPage(count){
      this.itemsPerPage = count
      this.fetch_search_data()
    },
    ws_on_message: function (message) {
      message = JSON.parse(message)
      let method = message.method
        let params = message.params
        if (method === 'send_recognized_plate' && this.ws_flag ) {
            this.push_table_data(params)
        }
        if (method === 'update_recognized_plates') {
          // this.update_table_data(params)
        }
        if (method === 'update_presence_time'){
          this.recognized_plates.forEach(function (item, i, arr){
            if(item['_id']['$oid'] === params["_id"]['$oid']){
              arr[i]["time_of_presence"] = params["time_of_presence"]
              console.log(arr[i]["time_of_presence"])
            }
          });
        }
    },
    prepare_time_of_precense(time_of_precense){
      let mins
      let secs
      if (time_of_precense === 0){
        secs = 0.001
        mins = 0
      }
      else {
        mins = Math.floor(time_of_precense / 60)
        secs = time_of_precense - mins * 60
      }

      return mins.toString() + ':' + secs.toFixed(3).toString()
    },
    fetch_table_data: function (page, itemsPerPage) {
      this.ws_flag = page === 1;
      console.log(this.ws_flag)
      this.$http({url: this.$http_hostname + '/recognition_journal/all?pagination=' + itemsPerPage + '&page=' + page, method: 'GET'})
      .then(resp => {
        let new_data = resp.data
        this.recognized_plates = []
        for (let plate of new_data["all_cars"]) {
          this.recognized_plates.unshift(
              plate
          )
        }
        this.pageCount = new_data["page_count"]
        this.table_loading = false
      })
      .catch(() => {
        this.table_loading = false
        this.setSnackbar({
          text: i18n.t('errors.error_during_data_loading')
        })
      })
    },
    fetch_search_data: function () {
      this.ws_flag = this.page === 1;
      let search
      if (this.search === null || this.search === ''){
        search = ''
      }
      else{
        search = this.normilize_license_plate(this.search)
        this.ws_flag = false
      }
      this.$http({url: this.$http_hostname + '/recognition_journal/all?pagination=' + this.itemsPerPage + '&page=' + this.page + '&plate=' + search, method: 'GET'})
      .then(resp => {
        let new_data = resp.data
        this.recognized_plates = []
        for (let plate of new_data["all_cars"]) {
          this.recognized_plates.unshift(
              plate
          )
        }
        this.pageCount = new_data["page_count"]
        this.table_loading = false
      })
      .catch(() => {
        this.table_loading = false
        this.setSnackbar({
          text: i18n.t('errors.error_during_data_loading')
        })
      })
    },
    push_table_data: function (params) {
      this.recognized_plates.unshift(params.plate)
    },
    plate_access_color: function (item) {
      switch (item.access_type) {
        case 'whitelist':
          if (!item.passage_allowed) {
            if (!item.disallow_reason) {
              return 'blue-grey lighten-3'
            }
            switch (item.disallow_reason) {
              // case 'no_permits':
              //   return 'indigo lighten-5'
              // case 'not_in_whitelist':
              //   return 'indigo lighten-5'
              case 'access_by_datetime_not_granted':
                return 'lime lighten-4'
              case 'is_suspended':
                return 'red lighten-4'
              case 'wrong_addressee':
                return "light-blue lighten-4"
              case 'wrong_direction':
                return "light-blue lighten-4"
              case 'came_too_early':
                  return "purple lighten-4"
            }
          } else {
            return 'green lighen-3'
          }
          break
        case 'blacklist':
          return 'grey darken-4'
        case 'known':
          return 'indigo lighten-5'
        case 'unknown':
          return 'indigo lighten-5'
      }
    },
    open_debug_tool () {
      let path = this.$i18nRoute({name: 'DebugTool'})
      console.log(`Opening debugging tools... ${JSON.stringify(path)}`)
      this.$router.push(path)
    },
    recognized_plates_sort(a, b) {
      if (moment(a.detection_datetime).isAfter(b.detection_datetime)) {
        return -1
      }
      if (moment(b.detection_datetime).isAfter(a.detection_datetime)) {
        return 1
      }
      return 0
    },
    fetchEntriesDebounced() {
      // cancel pending call
      clearTimeout(this._timerId)
      this.page = 1
      console.log(this.page)
      // delay new call 500ms
      this._timerId = setTimeout(() => {
        this.fetch_search_data()
      }, 500)
    }
  },
  computed: {
    recognized_plates_list () {
      let recognized_plates_list = []
      for (let plate of this.recognized_plates) {
        recognized_plates_list.push( {
          license_plate: plate.license_plate,
          detection_datetime: moment(plate.detection_datetime['$date']),
          country: 'Russia',
          source: plate.checkpoint_name + ' ' + plate.gate_name + ' ' + plate.cam_name,
          owner_fio: plate.owner_fio,
          access_type: plate.access_type,
          time_of_presence: plate.time_of_presence,
          access_by_datetime_granted: plate.access_by_datetime_granted,
          passage_allowed: plate.passage_allowed,
          disallow_reason: plate.disallow_reason,
          text_color: plate.access_type === 'blacklist' ? 'white' : 'black'
        })
      }
      return recognized_plates_list.sort(this.recognized_plates_sort)
    }
  },
  created () {
      this.fetch_search_data()
},
}

</script>

<style>
.search-field {
    max-width: 20vw;
}
.journal-title {
  display: flex;
  justify-content: space-between;
}
</style>